module.exports = __webpack_public_path__ + "static/media/simmons.8886cf46.webp";